import { toast } from 'react-toastify';
import { apiClient } from './client';
import { handleApiError } from './utils';

export const createFinalCompensation = async ({
    paymentCollections = [],
    accidentFile = [],
    arbitration = [],
    enforcement = []
}) => {
    try {
        const payload = {
            paymentCollections: Array.isArray(paymentCollections) ? paymentCollections.map(String) : [],
            accidentFile: Array.isArray(accidentFile) ? accidentFile.map(String) : [],
            arbitration: Array.isArray(arbitration) ? arbitration.map(String) : [],
            enforcement: Array.isArray(enforcement) ? enforcement.map(String) : []
        };

        const response = await apiClient.post('/FinalCompensation', payload);

        toast.success('Tahsilat kapağa başarıyla gönderildi.');
        return response.data;
    } catch (error) {
        handleApiError(error, 'Tahsilat kapağa gönderilemedi.', {
            toastPrefix: 'Tahsilat kapağa gönderilemedi: '
        });

        throw error;
    }
};

export const calculateTevkifat = async (amount, rates = {}) => {
    try {
        const params = { amount };
        if (rates.kdvRate != null) params.kdvRate = rates.kdvRate;
        if (rates.tevkifatRate != null) params.tevkifatRate = rates.tevkifatRate;
        if (rates.tevkifatLimit != null) params.tevkifatLimit = rates.tevkifatLimit;

        const response = await apiClient.get('/FinalCompensation/calculate-tevkifat', { params });
        return response.data;
    } catch (error) {
        handleApiError(error, 'Tevkifat hesaplanırken bir hata oluştu.');
        throw error;
    }
};

export const releaseFinalCompensationFromSelf = async ({ finalCompensationId }) => {
    if (!finalCompensationId) {
        toast.error('Görev kaldırma işlemi için kapak ID\'si gereklidir.');
        throw new Error('Final compensation ID is missing for release request.');
    }

    try {
        const response = await apiClient.put(`/FinalCompensation/release-task-from-user/${finalCompensationId}`);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Kapak görevi kaldırılırken hata oluştu.');
        throw error;
    }
};

export const finalizeCompensation = async ({ id }) => {
    if (!id) {
        toast.error('Kapak tamamlama işlemi için ID gereklidir.');
        throw new Error('Final compensation ID is missing.');
    }

    try {
        const response = await apiClient.put(`/FinalCompensation/finalize/${id}`);
        toast.success('Kapak başarıyla oluşturuldu.');
        return response.data;
    } catch (error) {
        handleApiError(error, 'Kapak tamamlanırken hata oluştu.');
        throw error;
    }
};

export const assignFinalCompensationToSelf = async ({ finalCompensationId }) => {
    if (!finalCompensationId) {
        toast.error('Kendine atama işlemi için kapak ID\'si gereklidir.');
        throw new Error('Final compensation ID is missing for assign to self request.');
    }

    try {
        const response = await apiClient.put(`/FinalCompensation/assign-task-to-user/${finalCompensationId}`);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Kapak kendine atama işlemi sırasında hata oluştu.');
        throw error;
    }
};

export const patchFinalCompensationInfo = async ({ id, payload }) => {
    if (!id) {
        toast.error('Kapak bilgisi güncellemesi için kayıt ID gereklidir.');
        throw new Error('Final compensation ID is missing.');
    }

    try {
        const response = await apiClient.patch(`/FinalCompensation/patch-compensation-info/${id}`, payload);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Kapak bilgileri güncellenirken bir hata oluştu.');
        throw error;
    }
};
